import { z } from 'zod';

/**
 * Stats: napi tenant-szintű olvasási aggregátum az analytics-svc-ből.
 */
export const StatsTrafficPointSchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  readingEvents: z.number().int().nonnegative(),
  readingMinutes: z.number().int().nonnegative(),
  activeReaders: z.number().int().nonnegative(),
});
export type StatsTrafficPoint = z.infer<typeof StatsTrafficPointSchema>;

export const StatsSnapshotSchema = z.object({
  tenantId: z.string(),
  windowDays: z.number().int().positive(),
  totalReadingMinutes: z.number().int().nonnegative(),
  totalActiveReaders: z.number().int().nonnegative(),
  daily: z.array(StatsTrafficPointSchema),
});
export type StatsSnapshot = z.infer<typeof StatsSnapshotSchema>;
